<template>
  <v-alert
    icon="mdi-cash-usd-outline"
    text
    type="warning"
    style="grid-area: price"
    outlined
    v-if="showAlert"
  >
    <span v-if="showReanalysisAlert"
      >Upon submission, VCGS will review this request and contact you, if
      necessary, regarding feasibility and pricing.
    </span>
    <span v-if="showVariantReviewAlert">
      Upon submission, VCGS will review this request and contact you, if
      necessary, regarding pricing
    </span>
    <span
      v-if="
        !summaryScreen &&
          !showVariantReviewAlert &&
          !showReanalysisAlert
      "
      >Price: ${{ price }} AUD
    </span>
  </v-alert>
</template>

<script>
export default {
  props: {
    price: Number,
    showReanalysisAlert: Boolean,
    showVariantReviewAlert: Boolean,
    summaryScreen: Boolean,
    billingDetail: Boolean,
  },
  computed: {
    showAlert() {
      if (
        this.summaryScreen &&
        ( this.showReanalysisAlert ||
          this.showVariantReviewAlert)
      )
        return true;

      if (
        this.billingDetail &&
        ( this.showReanalysisAlert ||
          this.price !== null)
      )
        return true;

      return false;
    },
  },
};
</script>
